<template>
  <div class="realizationPublic">
    <ul class="realizationScroll clearfix">
      <li class="col-lg-3 col-md-3 col-sm-3 col-xs-3" v-for="item in realizationInfo">
        <div class="purchaserLi">
          <div class="line hidden-xs hidden-sm"></div>
          <h4>{{item.title}}</h4>
          <div class="circle hidden-xs hidden-sm"><span></span></div>
          <p>{{item.content}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: ["realizationInfo"],
    data () {
      return {
      }
    },
    created () {
    },
    mounted () {
      this.ulWidth();
      this.resizeUlWidth();
    },
    methods: {
      ulWidth () {
        // 动态计算ul的宽度
        let scrollwrap = $('.realizationScroll')
        let lis = $('li', scrollwrap)
        let sum = 0
        // 遍历每一个li元素
        lis.each(function (index, el) {
          let _el = $(el)
          // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
          // outerWidth 代表的是border+padding+width
          sum += _el.outerWidth(true)
        })
        // 将累加的值直接复制给ul元素
        if($('.realizationPublic').width() < 720){
          scrollwrap.width(sum +16)
        }else{
          scrollwrap.width(sum)
        }
      },
      resizeUlWidth(){
        $(window).resize(() => {
          if($('.realizationPublic').width() < 720){
            this.ulWidth();
          }else{
            $('.realizationScroll').width('auto')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/realizationPublic/index.vue